import { AccountRegisterFormData } from "@/validations/account";

export const DEFAULT_ACCOUNT_REGISTER_FORM_SCHEMA: Partial<AccountRegisterFormData> = {
  family_name: "",
  family_name_kana: "",
  first_name: "",
  first_name_kana: "",
  birth_year: null,
  birth_month: null,
  address_prefecture: "",
  current_residence_type_id: null,
  home_loan_amount: "",
  real_estate_loan_amount: "",
  monthly_rent_payment_amount: "",
  job_category: "",
  job_industry: null,
  job_continuous_period: "",
  annual_income: "",
  financial_asset: "",
  interest_tag_ids: [],
  interested_property_type_ids: [],
  purpose_of_use_free_text: "",
  other_request_text: "",
  purpose_of_use_ids: [],
  inflow_route_free_text: "",
  inflow_route_ids: [],
  holding_property_count: "",
};
